import 'react-datepicker/dist/react-datepicker.css'
import { forwardRef, memo } from 'react'
import DatePickerInput from 'react-datepicker'
import { FaCalendarAlt } from 'react-icons/fa'
import moment from 'moment'
import Text from './Text'

const minAge = 18
const maxAge = 60

const DatePickerCustomInput = forwardRef(({ value, ...rest }, ref) => (
  <button
    type="button"
    {...rest}
    className={
      'flex px-4 py-2 border gap-x-2 items-center bg-white rounded-lg border-border-primary focus:border-border-accent-indigo-primary w-full focus:outline-none'
    }
    ref={ref}
  >
    <FaCalendarAlt className="text-foreground-quaternary" />
    {value}
  </button>
))

DatePickerCustomInput.displayName = 'DatePickerCustomInput'

const DatePickerComponent = ({
  value,
  placeholder,
  onChange,
  minDate = moment().subtract(maxAge, 'years').toDate(),
  maxDate = moment().subtract(minAge, 'years').toDate(),
  autoFocus,
  asPopup = false,
  label,
  ...rest
}) => {
  const selectedValue = value
    ? moment(value).isValid()
      ? moment(value).toDate()
      : maxDate || new Date()
    : maxDate || new Date()

  return (
    <div className="w-full flex flex-col items-start gap-1">
      {label && (
        <Text
          tag="span"
          size="medium"
          variant="label"
          className="text-text-primary"
        >
          {label}
        </Text>
      )}
      <DatePickerInput
        toggleCalendarOnIconClick
        placeholderText={placeholder}
        onChange={onChange}
        wrapperClassName="w-full"
        selected={selectedValue}
        minDate={minDate}
        maxDate={maxDate}
        autoFocus={autoFocus}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={60}
        peekNextMonth
        showMonthDropdown
        dropdownMode="scroll"
        dateFormat={'yyyy-MM-dd'}
        {...rest}
        customInput={<DatePickerCustomInput />}
        portalId="goodFlipPortal"
        withPortal={asPopup}
      />
    </div>
  )
}

const DatePicker = memo(DatePickerComponent)
export default DatePicker
